module.exports = __webpack_public_path__ + "img/in.0fdf05b8.jpg";